import React, { memo } from 'react'
import moment from 'moment'
import { TooltipTemplate } from './styled'
import { dateFormat } from '../DatePicker/Picker'

export const customerGroupsTooltip = ({
	headerText = 'PERIOD',
	footerText = 'TOTAL',
	labelFormatter,
	valueFormatter
}) => ({
	argumentText,
	value
}) => {
	const labelValue = labelFormatter
		? labelFormatter(argumentText)
		: moment(Number(argumentText), 'MM').format('MMMM')
	return (
		<TooltipTemplate style={{ boxShadow: 'none', padding: 0 }}>
			<div className='tooltip__header'>
				<h4>{headerText}:</h4>
				<span>{labelValue}</span>
			</div>
			<div className='tooltip__footer_today'>
				<h4>{footerText}:</h4>
				<span>{valueFormatter ? valueFormatter(value) : value}</span>
			</div>
		</TooltipTemplate>
	)
}

export const renderSalesTooltip = (t = () => { }, { headerText, footerText, compareText, headerValue, footerValue, compareValue }) => ({ active, payload }) => {
	if (active) {
		const { value, payload: { DatumZeit, dateTime } } = payload[0]
		return (
			<TooltipTemplate>
				<div className='tooltip__header'>
					<h4>{t(headerText)}:</h4>
					<span>{headerValue ?? moment(DatumZeit || dateTime).format(dateFormat)}</span>
				</div>
				<div className='tooltip__footer_today'>
					<h4>{t(footerText)}:</h4>
					<span>{footerValue ?? value}</span>
				</div>
				{compareText && payload[1] && (
					<div className='tooltip__footer_today' style={{ marginTop: 10 }}>
						<h4>{t(compareText)}:</h4>
						<span style={{ color: payload[1].color }}>{compareValue ?? payload[1].value}</span>
					</div>
				)}
			</TooltipTemplate>
		)
	}
	return null
}

export const SalesForecastXAxisTick = memo((props) => {
	const { payload, x, y } = props
	const isToday = moment(payload.value).isSame(moment().format('YYYY-MM-DD'))
	const topTickText = moment(payload.value).format('D MMMM')
	const year = moment(payload.value).year()
	return (
		<text fill={!isToday ? '#3e4c57' : '#91dccf'} x={x - (!isToday ? 40 : 20)} y={y + 10} textAnchor='start' fontSize={12}>
			{!isToday ? topTickText : 'Heute'}
			<tspan
				x={x - (!isToday ? 20 : 45)}
				y={y + 25}
				fill={!isToday ? '#3e4c57' : '#91dccf'}
				fontSize={!isToday ? 12 : 10}>
				{!isToday ? year : `${topTickText}, ${year}`}
			</tspan>
		</text>
	)
})

export const TopProductsXAxisTick = memo((props) => {
	const { payload, x, y } = props
	const topTickText = moment(payload.value).format('D MMMM')
	const year = moment(payload.value).year()
	return (
		<text fill='#3e4c57' x={x - 30} y={y + 10} textAnchor='start' fontSize={12}>
			{topTickText}
			<tspan
				x={x - 15}
				y={y + 25}
				fill='#3e4c57'
				fontSize={12}>
				{year}
			</tspan>
		</text>
	)
})
